export default __webpack_public_path__ + "814b8af68abaf2abd7688969b6c5eb5f.svg";